
import { ActivitySelectedFiltersBase } from '../selected-filters-base';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;

  onFiltersOrSortChange: (isStoreChanged?: boolean) => void;
}

export function ActivitySelectedFiltersFooter(props: IProps) {
  const { isVacationRentals, isCars, onFiltersOrSortChange } = props;

  return (
    <ActivitySelectedFiltersBase 
      title="activity.selectedFilters.footer"
      isVacationRentals={isVacationRentals}
      isCars={isCars}
      onFiltersOrSortChange={onFiltersOrSortChange}
      displayClearAll
      isCentered
    />
  );
}
